import { render } from "./OrderErrorModal.vue?vue&type=template&id=4d5a945c"
import script from "./OrderErrorModal.vue?vue&type=script&lang=js"
export * from "./OrderErrorModal.vue?vue&type=script&lang=js"

import "./OrderErrorModal.vue?vue&type=style&index=0&id=4d5a945c&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__